import { ReportPDFTemplate } from "../configs/reportPDFTemplate";
import { pdf } from "@react-pdf/renderer";
import { ReactElement } from "react";

export const getPDFLink = async () => {
  const blob = await pdf(<ReportPDFTemplate />).toBlob();
  const PDFLink = URL.createObjectURL(blob); // Update to allow string type
  return PDFLink;
};

// Renders a @react-pdf/renderer document to a blob, loads it into a hidden
// iframe, and triggers the browser's native print dialog on it.
export const printPdfDocument = async (document: ReactElement) => {
  const blob = await pdf(document).toBlob();
  const url = URL.createObjectURL(blob);

  const iframe = window.document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = url;
  window.document.body.appendChild(iframe);

  iframe.onload = () => {
    iframe.contentWindow?.print();
    URL.revokeObjectURL(url);
  };
};
